import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditBrandModal from 'appSrc/AdminPanel/pages/Modals/Brand/EditBrandModal';
import ProductSearchModal from 'appSrc/AdminPanel/pages/Modals/ProductSearch';
import { ExternalLink, PrimaryButton, DLRichTextOutput } from 'appSrc/components/UI';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import SortableProductsTable from './ProductsTable';
import { encodeForURI } from 'appSrc/utils';
import { tdcDomainMatch } from 'appSrc/utils/random';
import style from './styles/style.module.css';

class IndividualBrandPage extends Component {
    state = {
        fetching: true,
        brand: {},
        products: [],
        editing: false,
        addingProduct: false,
    }

    componentDidMount() {
        this.loadBrand( this.props.match.params.bid );
    }

    componentDidUpdate( prevProps ) {
        if( this.props.match.params.bid !== prevProps.match.params.bid ) {
            this.setState( { fetching: true } );
            this.loadBrand( this.props.match.params.bid );
        }
    }

    loadBrand = ( id ) => {
        this.props.getBrand( id )
        .then( ( brand ) => {
            this.setState( {
                fetching: false,
                brand: brand,
            } );
        } )
        .catch( () => {
            this.props.redirect( '/admin/brands/' );
        } );

        this.props.getBrandProducts( id )
        .then( ( products ) => {
            this.setState( { products } );
        } )
        .catch( () => {} );

    }

    openEditModal = () => {
        this.setState( { editing: true } );
    }

    onEditSubmit = ( brand ) => {
        if( brand == null ) {
            this.props.redirect( '/admin/content/' );
        } else {
            this.setState( { brand: { ...brand }, editing: false } );
        }
    }

    onEditClose = () => {
        this.setState( { editing: false } );
    }

    openProductModal = () => {
        this.setState( { addingProduct: true } );
    }

    closeProductModal = () => {
        this.setState( { addingProduct: false } );
    }

    addProduct = ( product ) => {
        var desireIds = this.state.products.map( product => product.desireid );
        desireIds.push( product.desireid );
        this.props.updateBrand( this.state.brand.id, { desireIds } )
        .then( () => {
            this.setState( ( altState ) => {
                altState.brand.desires.push( product );
                altState.products = altState.products.concat( [ product ] );
                return altState;
            } );
        } );
    }

    removeProduct = ( index ) => {
        var desireIds = this.state.products.map( product => product.desireid );
        desireIds.splice( index, 1 );
        this.props.updateBrabd( this.state.brand.id, { desireIds } )
        .then( () => {
            this.setState( ( altState ) => {
                altState.products.splice( index, 1 );
                altState.products = altState.products.slice( 0 );
                return altState;
            } );
        } );
    }

    onManualProductSort = ( o, s, data ) => {
        this.setState( ( prevState ) => {
            var movedProduct = prevState.products.splice( data.oldIndex, 1 )[ 0 ];
            prevState.products.splice( data.newIndex, 0, movedProduct );
            prevState.products = prevState.products.slice( 0 );
            var orderedProductIds = prevState.products.map( product => product.desireid );
            this.props.updateBrand( prevState.brand.id, { desireIds: orderedProductIds } );
            return prevState;
        } );
    }

    render() {
        const { fetching, brand, products } = this.state;

        if( fetching ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }

        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit Brand Data' onClick={ this.openEditModal } style={ { marginRight: '15px' } } />
                            <PrimaryButton label='Add Product' onClick={ this.openProductModal } style={ { marginRight: '15px' } } />
                            <ExternalLink target='_blank' to={ `${ tdcDomainMatch() }/brands/${ brand.id }/${ encodeForURI(brand.name) }` }>
                                <PrimaryButton reverse label='Public View' />
                            </ExternalLink>
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <div>
                            <ListCoverImage coverImage={ brand.cover_image } />
                        </div>
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ brand.name }</h2>
                            </div>
                            <div className={ style.description }>
                                <DLRichTextOutput content={ brand.description } />
                            </div>
                            <div className={ style.categories }>
                                <p>{ brand.categories.map( category => category.name ).join( ', ' ) }</p>
                            </div>
                        </div>
                    </div>
                    <div className={ style.tabs }>
                        <div className={ style.tabOption }
                        onClick={ () => { this.setState( { tab: 'products' } ); } }
                        data-active={ this.state.tab == 'products' }>
                            Products ({ products.length })
                        </div>
                    </div>
                </div>
                <div className={ style.body }>
                    <SortableProductsTable products={ products }
                    removeProduct={ this.removeProduct }
                    onSort={ this.onManualProductSort } />
                </div>
                { this.state.editing &&
                    <EditBrandModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    brand={ brand } />
                }
                { this.state.addingProduct &&
                    <ProductSearchModal closeModal={ this.closeProductModal }
                    onSubmit={ this.addProduct } markedProducts={ products } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        getBrand: ( id ) => {
            return dAPI.get( `/admin/brands/${ id }` );
        },
        updateBrand: ( id, data ) => {
            return dAPI.patch( `/admin/brands/${ id }`, data );
        },
        getBrandProducts: ( id ) => {
            return dAPI.get( `/admin/brands/${ id }/desires` );
        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualBrandPage );
